import haversine from 'haversine-distance';

export const formatNumber = (number: number | undefined, locale: string = 'fr-FR', decimals: number = 2): string => {
    if (number === undefined) return '-';
    return new Intl.NumberFormat(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    }).format(number);
};

export const parseNumberWithComma = (input: string): number => {
    const formattedInput = input.replace(',', '.');

    const parsedNumber = parseFloat(formattedInput);

    if (isNaN(parsedNumber)) {
        throw new Error('La chaîne ne peut pas être convertie en un nombre valide.');
    }

    return parsedNumber;
};

export const roundTo2Decimals = (num: number): number => {
    return Math.round(num * 100) / 100;
};

export const getCoordsFromAdresseDataGouv = async (address: string): Promise<{ lat: number; lon: number } | null> => {
    try {
        const response = await fetch(`https://api-adresse.data.gouv.fr/search/?q=${encodeURIComponent(address)}&limit=1`);
        const data = await response.json();

        if (data.features.length > 0) {
            const [lon, lat] = data.features[0].geometry.coordinates;
            return { lat, lon };
        }

        return null;
    } catch (error) {
        console.error('Erreur adresse.data.gouv.fr:', error);
        return null;
    }
};

export const getDistanceBetweenAddresses = async (from: string, to: string): Promise<number | null> => {
    try {
        const fromCoords = await getCoordsFromAdresseDataGouv(from);
        const toCoords = await getCoordsFromAdresseDataGouv(to);

        if (!fromCoords || !toCoords) return null;
        return haversine(fromCoords, toCoords) / 1000;
    } catch (error) {
        console.error('Erreur distance:', error);
        return null;
    }
};

export const formatBytes = (bytes: number) => {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};
